module.exports = __webpack_public_path__ + "media/images/icons/tehri-white-logo-13696570e685ed2303324faa6e01173e.svg";